import { useModal, useNFTContext } from "../../../../utils/ModalContext";
import CountdownTimer from "react-component-countdown-timer";
import Counter from "../../../../common/counter";
import Particle from "../../../../common/particle/v1";
import Button from "../../../../common/button";
import sectionBgVideo from "../../../../assets/images/banner/alpha_octopus_video.mp4";

import data from "../../../../assets/data/particle/bannerV2Particles";
import BannerStyleWrapper from "./Banner.style";
import CTAStyleWrapper from "../../cta/v1/Cta.style";
import { useEffect } from "react";

const Banner = () => {
  const { mintModalHandle } = useModal();
  const {isPresaleOpen, saleStart, presaleStart, saleStartLoading, presaleStartLoading, totalMint, maxReserved} = useNFTContext();
  const isLoading = isPresaleOpen && saleStartLoading || presaleStartLoading;

  const settings = {
    count: isPresaleOpen ? Math.floor(Number(saleStart) - Date.now() / 1000) : Math.floor((saleStart + 259200) - Date.now()/1000),
    showTitle: true,
    size: 60,
    labelSize: 14,
    backgroundColor: "transparent",
    color: "#fff",
    dayTitle: "",
    hourTitle: "",
    minuteTitle: "",
    secondTitle: "", 
    id: "countdownwrap",
  };
  const bgVideo = {
    width: "100vw",
  height: "100vh",
  objectFit: "cover",
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  opacity:0.3
  // zIndex: -1,
  }

  useEffect(() => {}, [saleStart, presaleStart, isPresaleOpen]);
  // console.log("check",saleStart,isPresaleOpen ? Math.floor(Number(saleStart) - Date.now() / 1000) : Math.floor(Number(saleStart+10800) - Date.now() / 1000));
  return (
    <BannerStyleWrapper className="bithu_v2_baner_sect" id="home">
      <video style={bgVideo} autoPlay loop muted={1} >
        <source src={sectionBgVideo} type="video/mp4" />
      </video>
      <div className="container">
        <div className="bithu_v2_baner_content">
          <h2>
            {" "}
            <span className="banner-emot">Revolutionary ART </span>
            {/* an Upcoming{" "}<br /> */}
            <span>Alpha Octopus🐙</span>
          </h2>
         
          <h3>
            <span className="count">
              <Counter end={totalMint + maxReserved} duration={100} />
            </span>{" "}
            / 888 Minted
          </h3>
          
          {/* <h3> {`NFT Collection`}</h3> */}
          
          {isPresaleOpen ? 
          <h3> Presale Is Live NOW</h3>
          :
          <h3> Public Mint Is Live NOW</h3>}
          <div className="bithu_v2_timer">
            {/* <h4>TIME LEFT</h4> */}
            <div className="timer timer_1">
              <CountdownTimer {...settings} />
            </div>
          </div>
          <div className="bithu_v2_baner_buttons text-center">
            <Button lg 
              variant="mint" 
              // onClick={() => mintModalHandle()}
              onClick={() => window.open("https://discord.gg/XEeghFerwh", "_blank")}
            >
              Whitelist Now
            </Button>
          </div>

          <Particle className="v2_baner_stars" particles={data} />
        </div>
      </div>
    </BannerStyleWrapper>
  );
};

export default Banner;
